import { render, staticRenderFns } from "./AddNewCaseView.vue?vue&type=template&id=2e494ae8&scoped=true&"
import script from "./AddNewCaseView.vue?vue&type=script&lang=js&"
export * from "./AddNewCaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e494ae8",
  null
  
)

export default component.exports